@if (description()) {
    <span class="ap-dropdown__description" data-testid="description" [attr.id]="uniqueId + '-description'">
        {{ description() }}
    </span>
}

<ng-content select="ap-context-explanation"></ng-content>

@if (helpTextPosition() === HelpTextPosition.ABOVE && helpText()) {
    <ng-container *ngTemplateOutlet="helpTextElement; context: { above: true }"></ng-container>
}

<label class="ap-dropdown">
    <span class="ap-dropdown__label" data-testid="label">
        {{ label() }}
    </span>

    <select
        class="ap-dropdown__select"
        data-testid="select"
        [attr.disabled]="isDisabled ? isDisabled : null"
        [attr.aria-invalid]="control ? control.invalid : null"
        [attr.aria-describedby]="ariaDescribedBy"
        [attr.autocomplete]="autocomplete() ? autocomplete() : 'off'"
        (change)="onDropdownChange($event)"
        (blur)="onDropdownBlur()"
    >
        <option hidden disabled value [attr.selected]="!value ? 'true' : null"></option>
        @for (option of options(); track $index) {
            @if (typeof option === 'object') {
                <option [attr.value]="$any(option).value" [attr.selected]="$any(option).value === value ? 'true' : null">
                    {{ $any(option).label }}
                </option>
            } @else {
                <option [attr.value]="option" [attr.selected]="option === value ? 'true' : null">{{ option }}</option>
            }
        }
    </select>
    <ap-icon class="ap-dropdown__icon" name="chevron-down" color="inherit" size="small" data-testid="icon"> </ap-icon>
</label>

@if (helpTextPosition() === HelpTextPosition.BELOW && helpText()) {
    <ng-container *ngTemplateOutlet="helpTextElement"></ng-container>
}

@if (control) {
    <ap-form-errors
        data-testid="errors"
        [control]="control"
        [messages]="messages()"
        [content]="content"
        [attr.id]="uniqueId + '-errors'"
    ></ap-form-errors>
}

<ng-template #helpTextElement let-above="above">
    <div
        class="ap-dropdown__help-text {{ above ? 'ap-dropdown__help-text--above' : 'ap-dropdown__help-text--below' }}"
        data-testid="help-text"
        [attr.id]="uniqueId + '-help-text'"
        [innerHTML]="helpText()"
    ></div>
</ng-template>
